/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useMutation } from '@tanstack/react-query';
import { RECAPTCHA_ACTIONS } from '../constants/recaptcha';
import { useApiKey, useRecaptchaManager, useSsoApiService } from './account';

export const useRequestPasswordlessCode = () => {
  const api = useSsoApiService();
  const apiKeyQuery = useApiKey();
  const recaptchaManager = useRecaptchaManager();

  return useMutation({
    mutationFn: async ({
      username,
      status,
    }: {
      username: string;
      status?: string;
    }) => {
      const clientKey = await apiKeyQuery.getToken();

      if (!clientKey) throw new Error('Missing API keys');

      return api.getPasswordLessLogin(
        status ? { username, status } : { username },
        clientKey.id || '',
        clientKey.apiKey || '',
        await recaptchaManager.execute(RECAPTCHA_ACTIONS.LOGIN),
      );
    },
  });
};
